import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useForm } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/$components';
import { FixedFooterButton, FixedFooterProps } from '@components';
import { ROUTES, useNavigation } from '@navigation';
import { useBankTerms, useNavigationStep, useUserInput } from '@store';

import { FixedFooterPlaceholderProps } from './fixedFooter';

interface FixedFooterHelperResources {
	back: string;
	continue: string;
}

interface FixedFooterHelperOutput {
	fixedFooterProps: FixedFooterProps;
}

export const useFixedFooterHelper = ({
	onSubmitCorporateForm,
}: FixedFooterPlaceholderProps): FixedFooterHelperOutput => {
	const {
		subscriptionPaymentOptions,
		subscriptionTermsAndConditionsBank,
		subscriptionSelectAccount,
		subscriptionCorporateData,
		subscriptionIntegratorData,
	} = ROUTES;
	const t = useTranslation();
	const { back, next } = useNavigation();
	const { termsWereAccepted: bankTermsAccepted } = useBankTerms();
	const { selectedIntegrator, forms, selectedAccount } = useUserInput();
	const { current: currentRoute } = useNavigationStep();

	const resources: FixedFooterHelperResources = {
		back: t('general.back'),
		continue: t('general.continue'),
	};

	const integratorForm = useForm('integratorData');

	const validFormIntegratorData = selectedIntegrator !== undefined ? forms?.integratorData?.isValid : false;

	const isCurrentRoute = (route: string) => currentRoute === route;

	const isDisabled = {
		[subscriptionSelectAccount]: isCurrentRoute(subscriptionSelectAccount) && !selectedAccount,
		[subscriptionCorporateData]: isCurrentRoute(subscriptionCorporateData) && !forms?.corporateData?.isValid,
		[subscriptionIntegratorData]: isCurrentRoute(subscriptionIntegratorData) && !validFormIntegratorData,
		[subscriptionTermsAndConditionsBank]: isCurrentRoute(subscriptionTermsAndConditionsBank) && !bankTermsAccepted,
	};

	const handleContinue = () => {
		if (isCurrentRoute(subscriptionCorporateData) && onSubmitCorporateForm) {
			onSubmitCorporateForm();
		} else if (isCurrentRoute(subscriptionIntegratorData)) {
			integratorForm.submit();
		}
		next();
	};

	const disabled = isDisabled[currentRoute];

	let button: FixedFooterButton | undefined = undefined;
	if (!isCurrentRoute(subscriptionPaymentOptions)) {
		button = {
			onClick: back,
			text: resources.back,
		};
	}
	const fixedFooterProps: FixedFooterProps = {
		rightButton: {
			onClick: handleContinue,
			disabled: disabled,
			text: resources.continue,
		},
		leftButton: button,
	};
	return { fixedFooterProps };
};
